import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /reports/* — every report nests here and shares the
// `report.view` gate. Individual reports may add finer gates later.
export const Route = createFileRoute('/_authenticated/reports')({
  component: ReportsLayout,
});

function ReportsLayout() {
  const { permissions, loading } = useMe();
  if (!loading && !permissions.has('report.view')) {
    return <NoAccess permission="report.view" resource="Reports" />;
  }
  return <Outlet />;
}
